export default ({...props}) => {
  const {space} = props.theme
  return `
        width:100%;
        [ap_type="secondary"] {
          height:${space(7)}px;
        }
    `
}
